import { SaveOutlined } from '@ant-design/icons';
import { Button, Col, Form, Row, Tabs } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import Summernote from '../../components/summernote/Summernote';
import { Setting } from '../../models/setting/Setting';
import { layThongTinCauHinh, luuCauHinh } from '../../services/setting';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';

const CauHinhKeHoachDaoTaoTab = () => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const [isLoadingBtn, setIsLoadingBtn] = useState<boolean>(false);
    const [settingData, setSettingData] = useState<Setting | null>(null);

    const layDuLieu = async () => {
        try {
            dispatch(showLoadingScreen());
            let rs = await layThongTinCauHinh();
            setSettingData(rs);
            form.setFieldsValue({
                noiDungPhan1: rs?.noiDungPhan1 || "",
                noiDungPhan3: rs?.noiDungPhan3 || "",
                noiDungPhan4: rs?.noiDungPhan4 || "",
            });
        } catch (err: any) {
            toast.error('Đã xảy ra lỗi, không lấy được cấu hình kế hoạch đào tạo!');
        }
        dispatch(hideLoadingScreen());
    };

    const onFinish = async (values: any) => {
        try {
            dispatch(showLoadingScreen());
            setIsLoadingBtn(true);
            
            const updatedSetting: Setting = {
                ...(settingData as Setting),
                noiDungPhan1: values.noiDungPhan1,
                noiDungPhan3: values.noiDungPhan3,
                noiDungPhan4: values.noiDungPhan4,
            };

            const rs = await luuCauHinh(updatedSetting);
            if (rs) {
                toast.success('Lưu cấu hình kế hoạch đào tạo thành công!');
                layDuLieu();
            } else {
                toast.error('Lưu không thành công!');
            }
        } catch (err: any) {
            toast.error(err?.message || 'Đã xảy ra lỗi, lưu không thành công!');
        }
        dispatch(hideLoadingScreen());
        setIsLoadingBtn(false);
    };

    useEffect(() => {
        layDuLieu();
    }, []);

    return <section>
        <Tabs
            defaultActiveKey="1"
            items={[
                {
                    key: '1',
                    label: 'Cấu hình mẫu Kế hoạch đào tạo năm',
                    children:
                        <div className="card">
                            <div className="card-body">
                                <Form
                                    layout="vertical"
                                    onFinish={onFinish}
                                    form={form}
                                >
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <Form.Item name="noiDungPhan1" label="Phần I: Mục đích, Yêu cầu">
                                                <Summernote minHeight={300} value={form.getFieldValue("noiDungPhan1")} onChange={(v) => form.setFieldValue("noiDungPhan1", v)} />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item name="noiDungPhan3" label="Phần III: Kinh phí thực hiện (Nội dung diễn giải)">
                                                <Summernote minHeight={200} value={form.getFieldValue("noiDungPhan3")} onChange={(v) => form.setFieldValue("noiDungPhan3", v)} />
                                            </Form.Item>
                                            <div style={{color: 'gray', marginBottom: '16px'}}>
                                                <i>Lưu ý: Bảng kinh phí và các số liệu dự kiến, dự phòng sẽ được hệ thống tự động tính toán và chèn vào bên dưới nội dung này khi xuất file Word.</i>
                                            </div>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item name="noiDungPhan4" label="Phần IV: Tổ chức thực hiện">
                                                <Summernote minHeight={300} value={form.getFieldValue("noiDungPhan4")} onChange={(v) => form.setFieldValue("noiDungPhan4", v)} />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24} style={{ textAlign: 'right' }}>
                                            <Button type="primary" loading={isLoadingBtn} htmlType="submit" icon={<SaveOutlined rev="" />}>
                                                Lưu Cấu Hình
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </div>
                }
            ]}
        />
    </section>
}

export default CauHinhKeHoachDaoTaoTab;
